export function dismissInstallBanner(state = false, action) {
  switch (action.type) {
    case "DISMISS_BANNER":
      return action.payload
    default:
      return state
  }
}
